/**
 * The Cloud board's drill-down URL vocabulary (dashboard design rules §4.2):
 * one place for the routes and search params the L1 sections and the L2
 * sub-routes share, so a donut segment, a "View all →" link and the L2
 * FilterRow can never disagree about what `?severity=` means.
 */

/** L2 sub-route: the full Azure Monitor alert list. */
export const CLOUD_ALERTS_PATH = "/cloud/alerts";

/** L2 sub-route: the full resource-change list. */
export const CLOUD_CHANGES_PATH = "/cloud/changes";

/** Multi-value param carrying selected subscription IDs (comma-joined). */
export const SUB_PARAM = "sub";

/** Multi-value param carrying selected alert severities (`Sev0`…`Sev4`). */
export const SEVERITY_PARAM = "severity";

/** Multi-value param carrying alert monitor conditions (`Fired`/`Resolved`). */
export const ALERT_STATE_PARAM = "state";

/** Multi-value param carrying change types (`Create`/`Update`/`Delete`). */
export const CHANGE_TYPE_PARAM = "type";

/** Single-value param carrying the alert whose detail drawer is open. */
export const ALERT_DRAWER_PARAM = "alert";
